export default {
    isAuth: !!localStorage.getItem('dtp_token'),
    isLoading: false,
}